import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Stats from './components/Stats/Stats';
import Products from './components/Products/Products';
import Process from './components/Process/Process';
import Quality from './components/Quality/Quality';
import About from './components/About/About';
import Testimonials from './components/Testimonials/Testimonials';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import ProductPage from './components/ProductPage/ProductPage';
import Disclaimer from './components/Disclaimer/Disclaimer';
import WhatsApp from './components/WhatsApp/WhatsApp';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { Analytics } from '@vercel/analytics/react';

const App: React.FC = () => {
  return (
    <Router>
      <ErrorBoundary>
        <div className="App">
          <Navbar />
          <main>
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <Hero />
                    <Stats />
                    <Products />
                    <Process />
                    <Quality />
                    <About />
                    <Testimonials />
                    <Contact />
                  </>
                }
              />
              <Route path="/product/:productId" element={<ProductPage />} />
            </Routes>
          </main>
          <Footer />
          <Disclaimer />
          <WhatsApp />
        </div>
      </ErrorBoundary>
      <Analytics />
    </Router>
  );
};

export default App;
